import React, { Component } from "react";
import {
	Card,
	Spin,
	Row,
	Col,
	Button,
	Form,
	Popconfirm,
	Icon,
	message,
	Upload,
	Dropdown,
	Menu,
	Input,
	Tabs,
	Slider
} from "antd";
import "ag-grid/dist/styles/ag-grid.css";
import "ag-grid/dist/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";

import AddEditLinkDialog from "./AddEditLinkDialog";
import BatchLinksDialog from "./BatchLinksDialog";
import { inject, observer } from "mobx-react";
import { autorun } from "mobx";
import moment from "moment";

const FormItem = Form.Item;

@inject("rootStore")
@observer
class LinksTab extends Component {
	editLink = e => {
		const {
			rootStore: { linksStore }
		} = this.props;

		if (e.event.target.className.indexOf("editLink") != -1) {
			linksStore.showEditLinkDialog(e.data);
		}
	};
	createGridDefs(columnDefs) {
		const gridDefs = {
			columnDefs: [
				{
					headerName: "ID",
					field: "id",
					editable: false,
					headerCheckboxSelection: true,
					checkboxSelection: true,
					sort: 'desc',
				},
				{
					headerName: "URL",
					field: "url",
					editable: false
				},
				{
					headerName: "Anchor (for lower tier)",
					field: "anchor",
					editable: false
				},
				{
					headerName: "Username",
					field: "username",
					editable: false
				},
				{
					headerName: "Password",
					field: "password",
					editable: false
				},
				{
					headerName: "Date Added",
					field: "dateAdded",
					editable: false,
					cellRenderer: params => {
						return moment(params.value).format("DD/MM/YY");
					}
				},
				{
					headerName: "Action",
					editable: false,
					cellRenderer: params => {
						// return "<button type='button' class='ant-btn ant-btn-primary ant-btn-sm'><i class='anticon anticon-plus-square-o'></i></button>"
						return (
							"<a class='editLink' data-id='" + params.data.id + "'>Edit</a>"
						);
					}
				}
			],
			rowSelection: "multiple"
		};
		return gridDefs;
	}

	deleteLinks = () => {
		const {
			rootStore: { linksStore }
		} = this.props;

		if (this.gridApi != null) {
			let linkIds = [];
			for (let node of this.gridApi.getSelectedNodes()) {
				const link = node.data;
				linkIds.push(link.id);
			}
			linksStore.remoteDeleteLinks(linkIds);
		}
	};

	onRowSelected = event => {
		if (event.node.group == false) {
			event.data.checked = event.node.selected;
		}
	};

	componentWillUnmount() {
		if (this.deleteLinksDisposer != null) {
			this.deleteLinksDisposer();
		}

		if (this.updateLinkDisposer != null) {
			this.updateLinkDisposer();
		}

		if (this.importLinksDisposer != null) {
			this.importLinksDisposer();
		}
	}

	showAddLinkDialog = () => {
		const {
			rootStore: { linksStore }
		} = this.props;

		linksStore.showAddLinkDialog();
	};

	showBatchLinksDialog = () => {
		const {
			rootStore: { linksStore }
		} = this.props;

		linksStore.showBatchLinksDialog();
	};

	onGridReady = params => {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;

		const {
			rootStore: { linksStore }
		} = this.props;

		const ui = linksStore.ui;

		this.deleteLinksDisposer = autorun(() => {
			if (ui.deletedLinkIds != null) {
				let deletedLinks = [];
				for (let id of ui.deletedLinkIds) {
					deletedLinks.push({
						id: id
					});
				}
				this.gridApi.updateRowData({
					remove: deletedLinks
				});
			}
		});

		this.updateLinkDisposer = autorun(() => {
			if (ui.updatedLink != null) {
				this.gridApi.updateRowData({
					update: [ui.updatedLink]
				});
			}
		});

		this.importLinksDisposer = autorun(() => {
			let updatedLinks = [];
			let newLinks = [];
			for (let link of ui.importedLinks) {
				const currentLink = this.gridApi.getRowNode(link.id);
				if (currentLink == null) {
					newLinks.push(link);
				} else {
					updatedLinks.push(link);
				}
			}
			if (ui.importedLinks != null) {
				this.gridApi.updateRowData({
					add: newLinks,
					update: updatedLinks
				});
			}
		});
	};

	handleExportLinksClick = ({key}) => {
		const {
			rootStore: { linksStore }
		} = this.props;

		const ui = linksStore.ui;

		let downloadLinksHref = "";

		if (key == "all_info") {
			downloadLinksHref = "/action/export/url_list/" + linksStore.urlList.id;
			window.open(downloadLinksHref, "_blank");
			return;
		}

		if (key == "links_only") {
			downloadLinksHref = "/action/export/url_list_only/" + linksStore.urlList.id;
			window.open(downloadLinksHref, "_blank");
			return;
		}

		if (key == "links_with_da") {
			downloadLinksHref = "/action/export/url_list_pr/" + linksStore.urlList.id;
			window.open(downloadLinksHref, "_blank");
			return;
		}
	};

	render() {
		const {
			rootStore: { linksStore }
		} = this.props;

		const ui = linksStore.ui;

		let spinning = ui.loadingLinks == true || ui.deletingLinks == true;

		const gridDefs = this.createGridDefs();

		const props = {
			name: "file",
			action: "/action/import/url_list/" + linksStore.urlList.id,
			showUploadList: false,
			onChange(info) {
				if (info.file.status !== "uploading") {
					// console.log(info.file, info.fileList);
				}
				if (info.file.status === "done") {
					message.success(`${info.file.name} file uploaded successfully`);
				} else if (info.file.status === "error") {
					message.error(`${info.file.name} file upload failed.`);
				}
			}
		};

		let exportLinksMenu = (
			<Menu onClick={this.handleExportLinksClick}>				
				<Menu.Item key="all_info">All Info</Menu.Item>
				<Menu.Item key="links_only">Only Links</Menu.Item>
				<Menu.Item key="links_with_da">Links with DA</Menu.Item>
			</Menu>
		);

		return (
			<Spin spinning={spinning}>
				<AddEditLinkDialog />
				<BatchLinksDialog />
				<Row>
					<Form layout="inline" style={{ marginBottom: 8 }}>
						<FormItem>
							<Button type="primary" onClick={this.showAddLinkDialog}>
								<Icon type="plus-square-o" />
							</Button>
						</FormItem>
						<FormItem>
							<Button type="primary" onClick={this.showBatchLinksDialog}>
								<Icon type="cloud-upload-o" />
							</Button>
						</FormItem>
						<FormItem>
							<Upload {...props}>
								<Button type="primary">
									<Icon type="upload" />
								</Button>
							</Upload>
						</FormItem>
						<FormItem>
							<Popconfirm
								title="Do you want to delete the selected links?"
								place
								ment="bottom"
								onConfirm={this.deleteLinks}
							>
								<Button type="primary">
									<Icon type="delete" />
								</Button>
							</Popconfirm>
						</FormItem>
						<FormItem>
							<Dropdown overlay={exportLinksMenu}>
							<Button type="primary">
									<Icon type="download" />
								</Button>
							</Dropdown>
							{/* <Button type="primary" href={downloadLinksHref}>
								<Icon type="download" />
							</Button> */}
						</FormItem>
					</Form>
				</Row>
				<Row>
					<div
						style={{
							width: "100%",
							height: window.screen.height * 3 / 4
						}}
					>
						<div
							style={{
								boxSizing: "border-box",
								height: "100%",
								width: "100%"
							}}
							className="ag-theme-balham"
						>
							<AgGridReact
								columnDefs={gridDefs.columnDefs}
								enableColResize={true}
								// enableFilter={false}
								// floatingFilter={true}
								enableSorting={true}
								rowData={linksStore.urls}
								enableRangeSelection={true}
								rowSelection={gridDefs.rowSelection}
								suppressRowClickSelection={true}
								onRowSelected={this.onRowSelected}
								onCellClicked={this.editLink}
								getRowNodeId={data => {
									return data.id;
								}}
								deltaRowDataMode={true}
								onGridReady={this.onGridReady}
							/>
						</div>
					</div>
				</Row>
			</Spin>
		);
	}
}

export default LinksTab;
